export const environment = {
  production: true,
  BACKEND: 'http://backend.planbdelivery.com.ar:8080'
};
